// Locked source of truth: 01_CLIENTS_LOCKED.pdf
// Names preserved verbatim (spelling, order, entities). X intentionally empty.
export const CLIENT_META = {
  label: "Explore · Index",
  title: "CLIENT INDEX",
  subtitle: "19 YEARS OF ONEWORLD. FROM A TO Z. ALMOST.",
  record: "209 CLIENT RELATIONSHIPS. ONE ALPHABETICAL RECORD.",
};

export const CLIENT_INDEX = [
  {
    letter: "A",
    names: [
      "ABBOT PHARMA",
      "ACCENTURE",
      "ACCENTURE POST TRADE",
      "ADENZA",
      "ADIDAS",
      "ADITYA BIRLA SPORTS",
      "ADITYA BIRLA SUNLIFE",
      "AFCONS",
      "AIRPORT AUTHORITY OF INDIA",
      "ALIGHT SOLUTIONS",
      "ALOK INDUSTRIES",
      "AMANORA MALLS PUNE",
      "AMERICAN EXPRESS",
      "AMFI (Association of Mutual Funds of India)",
      "ANAND RATHI",
      "ANGLO EASTERN",
      "ARKADE DEVELOPERS",
      "ARYA OMNITALK",
      "ASIAN PAINTS",
      "AXIS BANK",
      "AXIS CONSULTANTS",
      "AXIS MUTUAL FUND",
    ],
  },
  {
    letter: "B",
    names: [
      "BAJAJ ELECTIRCALS",
      "BANDHAN BANK",
      "BARCLAYS BANK",
      "BG GROUP",
      "BHARTI AXA",
      "BIRLA SUNLIFE MF",
      "BITE ADVERTSING",
      "BLACKSTONE CAPITAL",
      "BLOOMBERG",
      "BNP PARIBAS",
      "BOEHRINGER",
      "BOSTON CONSULTING",
      "BRITISH AIRWAYS",
    ],
  },
  {
    letter: "C",
    names: [
      "CAMPION SCHOOL",
      "CAP GEMINI",
      "CAPITAL FIRST",
      "CIO KLUB",
      "CISCO",
      "CITIBANK NA",
      "CITICORP SERVICES",
      "CMA",
      "CMA",
      "COLGATE",
      "COLORS TV",
      "CONTROL",
      "CORNERSTONE",
      "CRICKET CLUB OF INDIA",
      "CRISIL",
    ],
  },
  {
    letter: "D",
    names: [
      "DATAMATICS",
      "DATAVAIL",
      "DELL",
      "DEUTSCHE BANK",
      "DHL",
      "DIRECTI",
      "DISH HOSPITALITY",
      "DMART",
      "DOLAT CAPITAL",
      "DP WORLD",
    ],
  },
  {
    letter: "E",
    names: [
      "EDELWEISS",
      "EDENRED",
      "EDIFICE CONSULTANTS",
      "EMERITUS",
      "EMKAY",
      "ENFUSE SOLUTIONS",
      "ERNST & YOUNG",
      "EXIM BANK",
    ],
  },
  {
    letter: "F",
    names: ["FC BAYERN", "FCB ULKA", "FSS"],
  },
  {
    letter: "G",
    names: [
      "GARWARE CRICKET CLUB",
      "GEP",
      "GOLDFISH CAPITAL ADVISORS",
      "GOLDMAN SACHS",
      "GRANT THORNTON",
      "GROUP M",
      "GUJARAT FORTUNE GIANTS (ADANI)",
    ],
  },
  {
    letter: "H",
    names: [
      "Hapag Lloyd",
      "HDFC Bank",
      "HDFC ERGO",
      "HEWLETT PACKARD",
      "HIGH STREET PHOENIX",
      "HINDUSTAN UNILEVER",
      "HOSTWAY",
      "HSBC",
    ],
  },
  {
    letter: "I",
    names: [
      "ICAI",
      "ICICI BANK",
      "IDEA CELLULAR",
      "IDFC FIRST BANK",
      "IDFC SECURITIES",
      "IL&FS",
      "INDIABULLS",
      "INDIACAST",
      "INDIAN MEDICAL TENNIS SOCIETY",
      "INDIGO AIRLINES",
      "INDOSPACE",
      "INTERMEDICS",
    ],
  },
  {
    letter: "J",
    names: [
      "JET AIRWAYS",
      "JIOSTAR",
      "JITO",
      "JOHNSON & JOHNSON",
      "JP MORGAN",
      "JSW",
    ],
  },
  {
    letter: "K",
    names: [
      "KENNETH & LAW",
      "KGTI SCHOOL",
      "KOBELCO",
      "KOTAK ALTERNATE ASSETS MANAGEMENT CO",
      "KOTAK IB-IE",
      "KOTAK INSTITUTIONAL EQUITIES",
      "KOTAK MAHINDRA BANK",
      "KOTAK MAHINDRA CAPITAL CO",
      "KOTAK MAHINDRA LIFE INSURANCE",
      "KOTAK WEALTH",
      "KPMG",
      "KUSUM MASALA",
    ],
  },
  {
    letter: "L",
    names: ["LARSEN & TOUBRO", "LINTAS", "LODHA DEVELOPERS", "LOREAL"],
  },
  {
    letter: "M",
    names: [
      "M HEALTH",
      "M&G",
      "MACMERISE",
      "MADHUBAN TOYOTA",
      "MAHINDRA & MAHINDRA",
      "MAILORDER",
      "MARSH",
      "MARUDHAR MITRA MANDAL",
      "MAXICON SHIPPING",
      "MC KINSEY & CO",
      "MCDONALDS",
      "MERAKI",
      "MERCATOR",
      "MORGAN STANLEY",
      "MOTILAL OSWAL",
      "MSCI",
    ],
  },
  {
    letter: "N",
    names: [
      "NAYARA PETROLEIUM",
      "NECWS",
      "NIKE",
      "NOMURA",
      "NSE",
      "NSE IT",
      "NTT NETMAGIC",
    ],
  },
  {
    letter: "O",
    names: ["OC TANNER", "ORACLE", "ORANGE ADVERTISING", "ORG IMS", "OSIANS"],
  },
  {
    letter: "P",
    names: [
      "PATNI COMPUTERS",
      "PHOENIX MARKETCITY",
      "PREDATOR",
      "PRINCE MARINE SHIPPING",
      "PUNERI PALTAN (INSUREKOT)",
    ],
  },
  {
    letter: "Q",
    names: ["QUARTERFOLD PRINTS", "QUBE HEALTH"],
  },
  {
    letter: "R",
    names: [
      "RADIO ONE",
      "RAVE TECHNOLOGY",
      "RBL BANK",
      "RED BULL",
      "REFINITIV",
      "RELIANCE",
      "RELIANCE CAPITAL",
      "RICHMOND",
      "RIKA GLOBAL",
      "ROLTA",
      "ROUTE SMS / ROUTE MOBILE",
      "RTW Logisitics",
    ],
  },
  {
    letter: "S",
    names: [
      "SBI",
      "SBI LIFE",
      "SBI MUTUFAL FUND",
      "SEBI",
      "SERCO",
      "Shaadi.com",
      "SHELL BP",
      "SHINRAI TOYOTA",
      "SOLVAY CHEMICALS",
      "SONY PICTURES",
      "STANDARD CHARTERED BANK",
      "STAR TV",
      "STEELCASE",
      "STERLING WILSON",
      "SYNTEL",
    ],
  },
  {
    letter: "T",
    names: [
      "TAM",
      "TATA ADMIN SERVICES",
      "TATA MOTORS",
      "TATA POWER",
      "TATA PROJECTS",
      "TCS",
      "TECH MAHINDRA",
      "Teleperformance",
      "TEZI MANDI",
      "THOMSON REUTERS",
      "TIFR",
      "TRAFIGURA",
      "TRAVELEX",
    ],
  },
  {
    letter: "U",
    names: ["UBS BANK"],
  },
  {
    letter: "V",
    names: ["VIACOM", "VINAYAK MARINE SHIPPING", "VOLKSWAGEN"],
  },
  {
    letter: "W",
    names: [
      "WALT DISNEY",
      "WE-BUY",
      "WELSPUN",
      "WHITE OAK",
      "WILLIS TOWER WATSON",
      "WIPRO",
      "WNS",
    ],
  },
  {
    letter: "X",
    names: [],
  },
  {
    letter: "Y",
    names: ["Yes Bank"],
  },
  {
    letter: "Z",
    names: ["ZEE ENTERTAINMENT"],
  },
];
